module.exports = __webpack_public_path__ + "static/media/united-nations.55d742e4.png";